import { Info, AlertTriangle, CheckCircle2, Sparkles } from "lucide-react";
import { cn } from "@/lib/cn";

const variantMap = {
  info: {
    icon: Info,
    container: "border-brand/20 bg-brand-muted/40",
    iconClass: "text-brand",
  },
  note: {
    icon: Sparkles,
    container: "border-border bg-surface/60",
    iconClass: "text-muted-foreground",
  },
  warning: {
    icon: AlertTriangle,
    container: "border-amber-500/20 bg-amber-500/[0.06]",
    iconClass: "text-amber-600 dark:text-amber-400",
  },
  success: {
    icon: CheckCircle2,
    container: "border-emerald-500/20 bg-emerald-500/[0.06]",
    iconClass: "text-emerald-600 dark:text-emerald-400",
  },
};

export const Callout = ({
  variant = "info",
  title,
  children,
  className,
  testId,
}) => {
  const v = variantMap[variant] || variantMap.info;
  const Icon = v.icon;
  return (
    <div
      data-testid={testId || `callout-${variant}`}
      className={cn(
        "flex items-start gap-3 rounded-lg border p-4",
        v.container,
        className
      )}
    >
      <Icon className={cn("mt-0.5 h-4 w-4 shrink-0", v.iconClass)} aria-hidden="true" />
      <div className="flex flex-col gap-1">
        {title && (
          <div className="text-sm font-medium text-foreground">{title}</div>
        )}
        {children && (
          <div className="text-sm leading-relaxed text-muted-foreground">{children}</div>
        )}
      </div>
    </div>
  );
};

export default Callout;
